import { type DiscoverySport, SportCategory } from '../pages/Discover/Discover.types'

export const isSportABallsport = (sport?: DiscoverySport) => {
  return sport && sport.category !== SportCategory.FITNESS
}
